import type { VendorMediaKind } from '../enums/vendor-media-kind.enum.js'

/** Whether `host` is `domain` or one of its subdomains. */
function onDomain(host: string, domain: string): boolean {
  return host === domain || host.endsWith(`.${domain}`)
}

/**
 * Which site a vendor's video or audio link is on, or null for any other.
 *
 * By the address's host, never by a substring of it, so
 * `https://youtube.com.example.net/x` is not YouTube. Only http(s) addresses.
 */
export function mediaKindOf(url: string): VendorMediaKind | null {
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return null
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return null
  const host = parsed.hostname.toLowerCase()
  if (host === 'youtu.be' || onDomain(host, 'youtube.com')) return 'youtube'
  if (onDomain(host, 'vimeo.com')) return 'vimeo'
  if (onDomain(host, 'soundcloud.com')) return 'soundcloud'
  return null
}

/** Whether an http(s) address is on one of these sites (or their subdomains). */
export function onSite(url: string, domains: readonly string[]): boolean {
  let parsed: URL
  try {
    parsed = new URL(url)
  } catch {
    return false
  }
  if (parsed.protocol !== 'https:' && parsed.protocol !== 'http:') return false
  const host = parsed.hostname.toLowerCase()
  return domains.some((domain) => onDomain(host, domain))
}
